/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import {
  ApproveReviewAction,
  DomainNotIntegratedQuestion,
  EnsureFailedQuestion,
  MissingIntegrationCredentialQuestion,
  NativeCodeErrorQuestion,
  OAuth2MissingQuestion,
  ParseErrorQuestion,
  ProcedureNotKnownQuestion,
  RetryStepAction,
  ReviewConceptQuestion,
  SkipStepAction,
  SkipToEndOfRunAction,
  UseConceptAction,
  UseLiteralValueAction,
  UseNoValueAction,
  UseTechniqueAction,
  ValueNotKnownQuestion
} from '@/generated/graphql';
import { Moment } from 'moment';
import { IMiniPlaygroundProps } from '../MiniPlayground/interface';

export enum QuestionInputType {
  VALUE = 'value',
  VALUE_UPLOAD = 'value-upload',
  VALUE_CHOICE = 'value-choice',
  VALUE_EMPTY = 'value-empty',
  CONCEPT = 'concept',
  TECHNIQUE = 'technique',
  NO_VALUE = 'no-value',
  SKIP = 'skip',
  SKIP_RUN_END = 'skip-run-end',
  RETRY = 'retry',
  APPROVE_REVIEW = 'approve-review',
  NONE = '',
  RETRY_AFTER_INTERVAL = 'retry-after-interval',
  DOCUMENT_FIELDS = 'document-fields'
}

export interface IQuestionValueDocumentField {
  text: string;
  // location?: string;
}

export interface IQuestionValues {
  inputType: QuestionInputType;
  value?: string;
  upload?: { s3Url: string }[];
  choice?: string;
  technique?: string;
  remember?: boolean;
  secret?: boolean;
  retryDelayDateTime?: Moment;
  retryTimeoutMinutes?: number;
  documentFields?: IQuestionValueDocumentField[];
  draft?: boolean;
  published?: boolean;
  techniqueDocumentToken?: string;
}

export enum QuestionAnswerMode {
  SINGLE = 'single',
  BATCH = 'batch'
}

export interface IQuestionConfig {
  answerMode: QuestionAnswerMode;
  useSummaryQuestionText?: boolean;
  allowDocumentExceptionEditingInPopup?: boolean;
  autoSelectDocumentException?: boolean;
}

// TODO: rename to IRequestQuestion
export type RequestQuestionType =
  | DomainNotIntegratedQuestion
  | MissingIntegrationCredentialQuestion
  | NativeCodeErrorQuestion
  | OAuth2MissingQuestion
  | ProcedureNotKnownQuestion
  | ReviewConceptQuestion
  | ValueNotKnownQuestion
  | EnsureFailedQuestion
  | ParseErrorQuestion;

// TODO: rename to IAnswerAction
export type AnswerActionType =
  | UseConceptAction
  | UseLiteralValueAction
  | UseTechniqueAction
  | UseTechniqueAction
  | RetryStepAction
  | SkipStepAction
  | SkipToEndOfRunAction
  | ApproveReviewAction
  | UseNoValueAction;

export type OpenMiniPlaygroundMethod = (options: {
  source: IMiniPlaygroundProps['source'];
  miniPlaygroundToken: IMiniPlaygroundProps['miniPlaygroundToken'];
  miniPlaygroundText?: IMiniPlaygroundProps['miniPlaygroundText'];
  metadata?: IMiniPlaygroundProps['metadata'];
}) => void;
